// extracted by mini-css-extract-plugin
export default {"Container":"style_Container__GUGjD","Btn":"style_Btn__4iBUE","titleField":"style_titleField__LJZf+","red-span":"style_red-span__elLT4"};